import { Components } from '@mui/material';

export const stackConfigs: Components['MuiStack'] = {
  defaultProps: {
    direction: 'row',
    alignItems: 'center',
    gap: 2,
  },
};
